import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// Interface para projeto
interface Projeto {
  id: string
  nome: string
  descricao?: string
  status: string
  prioridade: string
  dataRecebimento: string
}

interface ProjetoState {
  projetos: Projeto[]
  currentProjeto: Projeto | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: number | null
    prioridade: number | null
  }
}

const initialState: ProjetoState = {
  projetos: [],
  currentProjeto: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: null,
    prioridade: null,
  },
}

const projetoSlice = createSlice({
  name: 'projeto',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setProjetos: (state, action: PayloadAction<Projeto[]>) => {
      state.projetos = action.payload
      state.isLoading = false
      state.error = null
    },
    setCurrentProjeto: (state, action: PayloadAction<Projeto>) => {
      state.currentProjeto = action.payload
    },
    addProjeto: (state, action: PayloadAction<Projeto>) => {
      state.projetos.unshift(action.payload)
    },
    updateProjeto: (state, action: PayloadAction<Projeto>) => {
      const index = state.projetos.findIndex(p => p.id === action.payload.id)
      if (index !== -1) {
        state.projetos[index] = action.payload
      }
    },
    removeProjeto: (state, action: PayloadAction<string>) => {
      state.projetos = state.projetos.filter(p => p.id !== action.payload)
    },
    setFilters: (state, action: PayloadAction<Partial<typeof initialState.filters>>) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isLoading = false
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setLoading,
  setProjetos,
  setCurrentProjeto,
  addProjeto,
  updateProjeto,
  removeProjeto,
  setFilters,
  setError,
  clearError,
} = projetoSlice.actions

export { projetoSlice }
